/* eslint-disable react/require-default-props */
import React from 'react';
import { Label } from '../../../atoms/Label';
/**
 * RadioItem Component
 * Renders a single radio input with label. Mirrors the Checkbox component structure.
 * Used internally by Radio and externally by ControlGroup for root-level radio items.
 * @version 2.0.0
 * @since 2026-03-09
 * @updated 2026-03-26 - Restructured to mirror Checkbox (div root, Label component, BEM classes)
 */
export function RadioItem({ name, value, checked, onChange, label, description, disabled = false, className = '' }) {
    const id = `${name}-${value}`;
    const containerClass = ['qmb-ui-radio', disabled ? 'qmb-ui-radio--disabled' : '', className]
        .filter(Boolean)
        .join(' ');
    return (React.createElement("div", { className: containerClass },
        React.createElement("input", { type: "radio", id: id, name: name, value: value, checked: checked, onChange: onChange, disabled: disabled }),
        label && (React.createElement(Label, { htmlFor: id, className: `qmb-ui-radio__label${description ? ' qmb-ui-radio__label--bold' : ''}` }, label)),
        description && React.createElement("span", { className: "qmb-ui-radio__description" }, description)));
}
